import _ from 'lodash';

const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
export const randomString = (len = 10) => {
  let text = '';
  for (let i = 0; i < len; i++) {
    text += randomPick(possible);
  }
  return text;
};

export const randomPick = (array) => {
  return array[0];
};

export const randomPicks = (array, count) => {
  const result = [];
  for (let i = 0; i < count; i++) {
    result.push(_.cloneDeep(randomPick(array)));
  }
  return result;
};